import { render, staticRenderFns } from "./AppBibleBuy.vue?vue&type=template&id=a363b86a&"
import script from "./AppBibleBuy.vue?vue&type=script&lang=js&"
export * from "./AppBibleBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports